import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { s3baseUri } from "../../config/config";
import { ArrowBack, DockOutlined, Visibility } from "@mui/icons-material";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";

import moment from "moment";
import { enqueueSnackbar } from "notistack";
import CustomMUITable from "../../components/customtable/CustomMuiTable";
import PageLoading from "../../components/loader/PageLoading";
import { useIds } from "../../hook/AdminContext";
import {
  addCommasToNumber,
  convertTimeToServerTimeZone,
  formatSalary,
  getFileIcon,
  handle_get_time_ago,
  show_proper_words,
} from "../../utils/Constant";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Avatar,
  Grid,
  IconButton,
  Tooltip,
  Divider,
  Box,
  TextField,
  useMediaQuery,
  InputAdornment,
  CircularProgress,
  Alert,
  AlertTitle,
} from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { FaS, FaXmarksLines } from "react-icons/fa6";
import AiLoader from "../../components/loader/AILoader";
import GeneralMUIDialog from "../../components/GeneralMUIDialog/GeneralMUIDialog";
import IdealCandidateButton from "./components/IdealCandidateButton";
import {
  ideal_candidate_list,
  candidates_list_api,
  change_job_applicant_status,
  update_application_read_unread_status,
  send_email_to_applicant,
  send_email_to_all_applicant,
} from "../../DAL/candidates/candidates";
import { Clock, DownloadIcon } from "lucide-react";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import TopBar from "../features/FeatureTopBar/components/TopBar";
import SearchIcon from "@mui/icons-material/Search";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircularLoader from "../../components/loader/CircularLoader";
import dayjs from "dayjs";
import {
  briefcase,
  calender_icon_with_back,
  eye_with_back_fill,
  eyeWithBorder,
  location_with_blue_back,
  salary_with_background,
  search_blue_icon,
  select_icon,
  time_icon,
} from "../../assets";
import CustomModalLayout from "../../components/modal/CustomModalLayout";
import CandidateDetails from "./components/CandidateDetails";
import DocumentModalboxCv from "../DocumentPreview/DocumentModalBoxcv";

const Candidates2 = ({
  isClientDetailsFlow = false,
  jobId = null,
  job = null,
  handleBack = () => {},
  isOpenInIdealCandidate = false,
  setJobCardToOpen = () => {},
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [cardToOpen, setCardToOpen] = useState("");
  const [membersList, setMembersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSendingMailToAll, setIsSendingMailToAll] = useState(false);
  const [openDetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [cvDialogOpen, setCvDialogOpen] = useState(false);
  const [cvDownloadLoading, setCvDownloadLoading] = useState(false);
  const [additionalDocDownloadLoading, setAdditionalDocDownloadLoading] =
    useState({});

  const [openIdealCandidates, setOpenIdealCandidates] = useState(false);

  const [openSendMailConfirmation, setOpenSendMailConfirmation] =
    useState(false);
  const [openSendMailToAllConfirmation, setOpenSendMailToAllConfirmation] =
    useState(false);

  const {
    findId,
    setBreadCrumb,
    userInfo,
    handleEmailClick,
    GetAccessOfCompany,
    adminSetting,
  } = useIds();
  const location = useLocation();
  const { state } = useLocation();
  const [jobs, setJobs] = useState(job || state?.job || null);
  const [emailSendTime, setEmailSendTime] = useState("");
  const [isProcessingContinue, setIsProcessingContinue] = useState(
    job?.scanning_cvs || state?.job?.scanning_cvs || false
  );

  const navigate = useNavigate();
  const params = useParams();
  const [dataapi, setDataApi] = useState();
  const [hoveredId, setHoveredId] = useState(null);
  const [apiResponce, setApiResponce] = useState(null);
  const [targetValue, setTargetValue] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  // search and pagination handle

  const isMobile = useMediaQuery("(max-width:600px)");
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");

  // load more functionality
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [latest, setLatest] = useState("true"); // default Recent
  console.log(latest, "hiiiii");

  const handleNavigateIdealCandidates = () => {
    if (isClientDetailsFlow) {
      setJobCardToOpen("ideal_candidate_list");
    } else {
      navigate(`${location.pathname}/ideal-candidates`);
    }
  };

  const searchFunction = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setPage(0);
    if (page == 0) {
      fetchData();
    }
  };

  const handleChangePage = (event, newPage) => {
    setIsLoading(true);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setIsLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePreviewClick = (row) => {
    setSelectedMember(row);
    setCvDialogOpen(true);
    setOpenDetailPopup(false);
  };
  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewUrl("");
  };
  const handleCloseCvDialog = () => {
    setCvDialogOpen(false);
    setSelectedMember(null);
  };
  const typesList = [
    {
      value: "true",
      title: "Latest",
    },
    {
      value: "false",
      title: "Oldest",
    },
  ];

  const TABLE_HEAD = [
    { id: "action", label: "Action", type: "action" },
    { id: "number", label: "#", type: "number" },
    { id: "name_profile", label: "Image ", type: "title_with_img" },
    { id: "first_name", label: "First Name" },
    { id: "last_name", label: "Last Name" },

    // {
    //   id: "email",
    //   label: "Email",
    //   type: "email",
    //   renderData: (row) => {
    //     const handleEmailClick = () => {
    //       // Safely get email and name with fallbacks
    //       const email = row?.email;
    //       const name = row?.name || "";

    //       // Create properly encoded URL
    //       const gmailUrl =
    //         `https://mail.google.com/mail/u/0/#inbox?compose=new` +
    //         `&to=${encodeURIComponent("zeeshankhalid1796@gmail.com")}` +
    //         `&su=${encodeURIComponent(`Regarding ${name}'s account`)}` +
    //         `&body=${encodeURIComponent(`Hello ${name},\n\n`)}`;

    //       window.open(gmailUrl, "_blank", "noopener,noreferrer");
    //     };

    //     return (
    //       <a
    //         href={`mailto:${"zeeshankhalid1796@gmail.com"}`}
    //         onClick={(e) => {
    //           e.preventDefault();
    //           handleEmailClick();
    //         }}
    //         style={{
    //           cursor: "pointer",
    //           color: "blue",
    //           textDecoration: "underline",
    //         }}
    //         title={`Email ${row.email}`}
    //       >
    //         {row.email}
    //       </a>
    //     );
    //   },
    // },
    {
      id: "email",
      label: "Email",
      type: "email",
      renderData: (row) => {
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${row.email}`;

        return (
          <span
            onClick={() => {
              handleEmailClick(row.email);
            }}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            className="text-primary-color"
          >
            {row.email}
          </span>
        );
      },
    },
    { id: "date_of_birth", label: "Applied  At" },
    {
      id: "cv",
      label: "CV",
      renderData: (row) => {
        return (
          <Tooltip title="Preview/Download CV">
            <IconButton
              onClick={() => handlePreviewClick(row)}
              sx={{ color: "navy" }}
            >
              <Visibility sx={{ fontSize: 28 }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];
  const docs = [
    {
      uri: s3baseUri + dataapi?.cv,
      name: dataapi?.cv,
    },
  ];
  const firstSegment = location.pathname.split("/")[1];

  const fetchData = async (page = 0, loadingMore = false) => {
    if (!loadingMore) {
      setIsLoading(true);
    }
    const response = isOpenInIdealCandidate
      ? await ideal_candidate_list(
          params.job_id || jobId,
          page,
          rowsPerPage,
          searchText,
          cardToOpen == "new-candidates"
            ? "pending"
            : cardToOpen.replace("-candidates", ""),
          latest
        )
      : await candidates_list_api(
          params.job_id || jobId,
          page,
          rowsPerPage,
          searchText,
          cardToOpen == "new-candidates"
            ? "pending"
            : cardToOpen.replace("-candidates", ""),
          latest
        );

    if (response.code === 200) {
      const members = response.job_application?.leaders.map((member) => ({
        ...member,
        name_profile: {
          image: member?.created_by?.profile_image?.thumbnail_1
            ? s3baseUri + member?.created_by?.profile_image?.thumbnail_1
            : "",
        },
        first_name:
          member.created_by?.first_name ?? member.created_by?.company_name,
        last_name: member.created_by?.last_name ?? "NA",
        date_of_birth: moment(member?.createdAt).format("DD/MM/YYYY hh:mm A"),
        biography: member?.biography,
        email: member?.created_by?.email,
        cv: member?.cv,
      }));

      setTotalCount(response.job_application.total_count);
      setPageNumber(page);
      setTotalPages(response.job_application.total_pages);
      setJobs(response?.job_application?.job_detail);
      if (response?.job_application?.setting?.send_time) {
        setEmailSendTime(
          convertTimeToServerTimeZone(
            response?.job_application?.setting?.send_time,
            adminSetting?.time_zone,
            userTimeZone
          )
        );
      }

      if (loadingMore) {
        setMembersList([...membersList, ...members]);
      } else {
        setMembersList(members);
      }

      if (isOpenInIdealCandidate) {
        if (!response?.job_application?.job_detail?.scanning_cvs) {
          // setTimeout(() => {
          setApiResponce(response.job_application);
          setIsLoading(false);
          setIsLoadingMore(false);
          setIsProcessingContinue(false);
          // }, 3000);
        } else {
          setIsProcessingContinue(true);
        }
      } else {
        setApiResponce(response.job_application);
        setIsLoading(false);
        setIsLoadingMore(false);
      }
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };
  const getFileExtension = (url) => {
    try {
      return url.split(".").pop().split("?")[0].toLowerCase();
    } catch {
      return "";
    }
  };

  const handleChangeStatusOfCandidate = async (obj, value) => {
    if (
      obj.manual_email_sent ||
      obj.schedule_email_sent ||
      obj.immediate_email_sent
    ) {
      setSelectedMember(obj);
      setTargetValue(value);
      setOpenConfirmation(true);
      return;
    }
    handleContinueToChangeStatusOfCandidate(obj, value);
  };

  const handleSendEmailToAll = async () => {
    setIsSendingMailToAll(true);
    setOpenSendMailToAllConfirmation(false);

    console.log(params.job_id, "job-d");
    const postData = {
      send_type: cardToOpen.replace("-candidates", ""),
      job_id: params.job_id,
    };

    const resp = await send_email_to_all_applicant(postData);
    if (resp.code == 200) {
      setMembersList((prev) =>
        prev.map((candidate) => ({ ...candidate, manual_email_sent: true }))
      );
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsSendingMailToAll(false);
  };

  const handleContinueToChangeStatusOfCandidate = async (obj, value) => {
    handleLoadingStatusInList(obj._id, value, true);
    if (selectedMember) {
      setSelectedMember((prev) => ({
        ...prev,
        [`${value}_loading`]: true,
      }));
    }
    const postData = {
      applicant_id: obj._id,
      response: value,
    };
    const resp = await change_job_applicant_status(postData);
    if (resp.code == 200 || resp.message.includes("code=210")) {
      setMembersList((prev) =>
        prev.filter((candidate) => obj._id !== candidate._id)
      );
      if (selectedMember) {
        setSelectedMember((prev) => ({
          ...prev,
          [`application_response`]: value,
        }));
      }

      if (resp.message.includes("code=210")) {
        enqueueSnackbar(
          resp.message
            .replace("short_listed", "shortlisted")
            .replace("code=210", ""),
          {
            variant: "info",
          }
        );
      } else {
        enqueueSnackbar(resp.message, {
          variant: "success",
        });
      }
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }

    handleLoadingStatusInList(obj._id, value, false);
    if (selectedMember) {
      setSelectedMember((prev) => ({
        ...prev,
        [`${value}_loading`]: false,
      }));
    }
  };

  const handleSendEmailConfirmation = (member) => {
    setOpenSendMailConfirmation(true);
    setSelectedMember(member);
  };

  const handleSendEmail = async () => {
    handleLoadingStatusInList(selectedMember._id, "send_email", true);
    setOpenSendMailConfirmation(false);
    const postData = {
      applicant_id: selectedMember._id,
      response: selectedMember.application_response,
    };
    const resp = await send_email_to_applicant(postData);
    if (resp.code == 200) {
      setMembersList((prev) =>
        prev.map((candidate) =>
          selectedMember._id === candidate._id
            ? { ...candidate, manual_email_sent: true }
            : candidate
        )
      );
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    handleLoadingStatusInList(selectedMember._id, "send_email", false);
  };

  const handleChangeReadStatus = async (obj, value, showSnackBar = false) => {
    handleLoadingStatusInList(obj._id, "read_status", true);

    const postData = {
      read_status: value,
    };
    const resp = await update_application_read_unread_status(postData, obj._id);
    if (resp.code == 200) {
      setMembersList((prev) =>
        prev.map((candidate) =>
          obj._id === candidate._id
            ? { ...candidate, read_status: value }
            : candidate
        )
      );

      if (showSnackBar) {
        enqueueSnackbar(resp.message, { variant: "success" });
      }
    } else {
      if (showSnackBar) {
        enqueueSnackbar(resp.message, { variant: "error" });
      }
    }
    handleLoadingStatusInList(obj._id, "read_status", false);
  };

  const handleLoadingStatusInList = (id, name, value) => {
    setMembersList((prev) =>
      prev.map((candidate) =>
        id === candidate._id
          ? { ...candidate, [`${name}_loading`]: value }
          : candidate
      )
    );
  };

  const handleDownloadAdditiondOC = async (documentPath) => {
    const fileUrl = `${s3baseUri}${documentPath}`;
    const filename = documentPath.split("/").pop();

    try {
      setAdditionalDocDownloadLoading((prev) => ({
        ...prev,
        [documentPath]: true,
      }));

      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setAdditionalDocDownloadLoading((prev) => ({
        ...prev,
        [documentPath]: false,
      }));
    }
  };
  const handleViewCv = () => {
    if (!selectedMember?.cv) {
      enqueueSnackbar("No CV available to view", { variant: "error" });
      return;
    }

    const fileUrl = encodeURIComponent(s3baseUri + selectedMember.cv);

    const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`;

    window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
  };

  const handleDownloadClick = async () => {
    if (selectedMember?.cv) {
      try {
        setCvDownloadLoading(true);
        // Fetch the file data
        const response = await fetch(s3baseUri + selectedMember.cv, {
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const fileExtension = selectedMember.cv.split(".").pop();
        const cvName = selectedMember.cv.split("/").pop();
        const firstName =
          selectedMember?.first_name?.trim() ||
          userInfo?.first_name?.trim() ||
          userInfo?.company_name?.trim();
        const lastName =
          selectedMember?.last_name?.trim() ||
          userInfo?.last_name?.trim() ||
          "";

        const fullName =
          `${firstName} ${lastName}`.trim().replace(/\s+/g, "_") ||
          "unknown_user";

        const fileName = `CV_${fullName}.${fileExtension}`;

        // Create a link element
        const link = document.createElement("a");
        link.href = url;
        link.download = cvName || fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the object URL after download
        window.URL.revokeObjectURL(url);
      } catch (error) {
        enqueueSnackbar("Error downloading the file", { variant: "error" });
        console.error("Download error:", error);
      } finally {
        setCvDownloadLoading(false);
      }
    } else {
      enqueueSnackbar("No CV available to download", { variant: "error" });
    }
  };
  const isFromMyJobPost =
    location.pathname.includes("/my-job-post/") ||
    location.state?.pathname?.includes("my-job-post");

  const breadcrumbPath = isFromMyJobPost
    ? `/${firstSegment}/live-job-feed/my-job-post`
    : `/${firstSegment}/live-job-feed`;

  useEffect(() => {
    if (isClientDetailsFlow) return;
    let list = [
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: breadcrumbPath, // ✅ Dynamic path based on source
        active: false,
      },
      {
        name: isOpenInIdealCandidate ? `Ideal Candidates` : `Candidates`,
        path: `${location.pathname}`,
        active: true,
      },
    ];

    if (isOpenInIdealCandidate) {
      list.push({
        name: `Candidates`,
        path: `${location.pathname.replace("/ideal-candidates", "")}`,
        active: false,
      });
    }
    setBreadCrumb(list);
  }, [navigate]);

  const handleDetailPopUp = (member) => {
    setSelectedMember(member);
    setOpenDetailPopup(true);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
    setSelectedMember(null);
  };
  const MENU_OPTIONS = [
    {
      label: "View Details",
      icon: "bxs:detail",
      handleClick: handleDetailPopUp,
    },
  ];

  const topBarList = [
    {
      title: "New Candidates",
      id: "new-candidates",
      icon: "material-symbols-light:overview-key-outline",
      countName: "pending_count",
    },
    {
      title: "Shortlisted Candidates",
      id: "short_listed-candidates",
      icon: "stash:user-avatar-light",
      countName: "short_listed_count",
    },
    {
      title: "Accepted Candidates",
      id: "accepted-candidates",
      icon: "stash:user-avatar-light",
      countName: "accepted_count",
    },
    {
      title: "Rejected Candidates",
      id: "rejected-candidates",
      icon: "fluent-mdl2:insights",
      countName: "rejected_count",
    },
  ];

  const handleMarkAsRead = (candidate) => {
    handleChangeReadStatus(candidate, true);
  };

  const handleMarkAsUnread = (candidate) => {
    handleChangeReadStatus(candidate, false);
  };

  const get_title_of_value = (value) => {
    return topBarList.find((obj) => obj.id == value)?.title || "";
  };

  const handleGetMenuList = (candidate) => {
    let list = [
      {
        label: "View Details",
        icon: "bxs:detail",
        handleClick: handleDetailPopUp,
      },
      {
        label: "Send Email",
        icon: "octicon:unread-16",
        handleClick: () => handleSendEmailConfirmation(candidate),
        disabled: candidate.application_response == "pending",
        tooltip:
          candidate.application_response == "pending"
            ? "Before sending email, kindly accept or reject application."
            : "",
      },
      {
        label: candidate.read_status ? "Mark As Unread" : "Mark As Read",
        icon: candidate.read_status
          ? "hugeicons:check-unread-02"
          : "solar:check-read-linear",
        handleClick: () =>
          handleChangeReadStatus(candidate, !candidate.read_status),
      },
    ];

    return list;
  };

  const handleSetCardToOpen = (id) => {
    setSearchText("");
    // setSearch("");
    setCardToOpen(id);
    if (!isClientDetailsFlow) {
      searchParams.set("candidate-tab", id);
      setSearchParams(searchParams);
    }
  };

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setPageNumber(pageNumber + 1);
    fetchData(pageNumber + 1, true);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchText(search);
    }, 800);
    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    if (cardToOpen) {
      fetchData();
    }
  }, [cardToOpen, searchText, latest]);

  useEffect(() => {
    // if (isOpenInIdealCandidate && !isClientDetailsFlow) {
    //   const jobKey = `ideal_candidate_${params.job_id || jobId || "unknown"}`;
    //   const storedTime = sessionStorage.getItem(jobKey);
    //   const storedCount = sessionStorage.getItem(`${jobKey}_opened`);
    //   if (storedTime && storedCount) {
    //     const elapsed = Math.floor(
    //       (Date.now() - parseInt(storedTime, 10)) / 1000
    //     );
    //     if (elapsed < 120) {
    //       navigate(`${location.pathname.replace("/ideal-candidates", "")}`, {
    //         replace: true,
    //       });
    //       return;
    //     }
    //   } else {
    //     sessionStorage.setItem(`${jobKey}_opened`, "true");
    //   }
    // }

    setCardToOpen(searchParams.get("candidate-tab") || "new-candidates");
    if (cardToOpen == "new-candidates") {
      fetchData();
    }
  }, [navigate, isOpenInIdealCandidate]);

  return (
    <>
      {cvDialogOpen && (
        <DocumentModalboxCv
          open={cvDialogOpen}
          handleClose={handleCloseCvDialog}
          image_url={selectedMember?.cv ? s3baseUri + selectedMember.cv : ""}
          type={getFileExtension(selectedMember?.cv)}
          previewDoc={selectedMember}
          data={selectedMember}
          handleChangeReadStatus={handleChangeReadStatus}
          handleChangeStatusOfCandidate={handleChangeStatusOfCandidate}
        />
      )}
      {openSendMailConfirmation && (
        <CustomConfirmation
          open={openSendMailConfirmation}
          setOpen={() => {
            setOpenSendMailConfirmation(false);
          }}
          title={`Are you sure to send email to ${
            selectedMember.first_name || ""
          } ${selectedMember.last_name || ""}?`}
          headerHeading={"Send Mail"}
          handleAgree={() => {
            handleSendEmail();
          }}
        />
      )}
      {openSendMailToAllConfirmation && (
        <CustomConfirmation
          open={openSendMailToAllConfirmation}
          setOpen={() => {
            setOpenSendMailToAllConfirmation(false);
          }}
          title={`Are you sure to send email to all?`}
          headerHeading={"Send Mail To All"}
          handleAgree={() => {
            handleSendEmailToAll();
          }}
          infoTitle={"Warning"}
          additionalInfo={
            "The email will be delivered to all users who have not received it so far."
          }
        />
      )}
      {openConfirmation && (
        <CustomConfirmation
          open={openConfirmation}
          setOpen={() => {
            setOpenConfirmation(false);
          }}
          title={`Are you sure you want to move this candidate to ${targetValue} candidates?`}
          headerHeading={"Move Candidate"}
          handleAgree={() => {
            setOpenConfirmation(false);
            handleContinueToChangeStatusOfCandidate(
              selectedMember,
              targetValue
            );
          }}
          additionalInfo={`An email has already been sent to this candidate. Since the status is being updated again, 
            the system cannot send another automatic email. If you need to notify the candidate, Please send a manual email.`}
          infoTitle={"Warning"}
        />
      )}

      {openIdealCandidates && (
        <GeneralMUIDialog
          open={openIdealCandidates}
          maxWidth="lg"
          setOpen={setOpenIdealCandidates}
          title={"Ideal Candidates"}
          showActionButton={false}
          cancelText={"Close"}
          content={
            <>
              <Candidates2
                isClientDetailsFlow={true}
                jobId={params.jobId}
                isOpenInIdealCandidate={true}
                job={jobs}
              />
            </>
          }
        />
      )}

      <div className={`${isClientDetailsFlow ? "" : "container-fluid"}`}>
        <div className="row align-items-center">
          {isClientDetailsFlow ? (
            <>
              <div
                className={`col-12 ${
                  isClientDetailsFlow ? "" : "mt-2"
                } mb-3 main-heading-live-jobs d-flex justify-content-between`}
              >
                <h6 className="tw-mb-3">
                  <>
                    <IconButton
                      className="me-1"
                      size="small"
                      onClick={() => {
                        handleBack("job");
                      }}
                    >
                      <ArrowBack fontSize="small" />
                    </IconButton>
                    {isOpenInIdealCandidate
                      ? "Ideal Candidates"
                      : "Job Candidates"}{" "}
                    {jobs?.job_title && (
                      <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                        ({jobs?.job_title || "N/A"})
                      </span>
                    )}
                  </>
                </h6>
                {!isLoading &&
                  !isOpenInIdealCandidate &&
                  (GetAccessOfCompany("job?.add") ||
                    GetAccessOfCompany("job?.update")) && (
                    <IdealCandidateButton
                      setOpenIdealCandidates={() =>
                        handleNavigateIdealCandidates()
                      }
                      job={jobs}
                    />
                  )}
              </div>
            </>
          ) : (
            <div className="col-12 my-2 mb-4 heading-live-jobs d-flex justify-content-center justify-content-lg-between align-items-center">
              <h2>
                {isOpenInIdealCandidate ? "Ideal Candidates" : "Candidates"}{" "}
                {jobs?.job_title && <span>({jobs?.job_title || "N/A"})</span>}
              </h2>
              {!isLoading &&
                !isOpenInIdealCandidate &&
                (GetAccessOfCompany("job?.add") ||
                  GetAccessOfCompany("job?.update")) && (
                  <IdealCandidateButton
                    setOpenIdealCandidates={() =>
                      handleNavigateIdealCandidates()
                    }
                    job={jobs}
                  />
                )}
            </div>
          )}

          <div className="col-12">
            <TopBar
              items={topBarList}
              cardToOpen={cardToOpen}
              setCardToOpen={handleSetCardToOpen}
              isDisabled={isLoading}
              isShowCount={isOpenInIdealCandidate}
              countObj={apiResponce}
            />
            <div className="mt-4 d-flex justify-content-center justify-content-md-between align-items-center overview-coaches">
              <h6 className="mb-0">{get_title_of_value(cardToOpen)}</h6>
              <div className="d-flex align-items-end justify-content-center tw-gap-2 ">
                {cardToOpen !== "new-candidates" &&
                cardToOpen !== "short_listed-candidates" &&
                (GetAccessOfCompany("job?.add") ||
                  GetAccessOfCompany("job?.update")) &&
                membersList.length > 0 &&
                !isLoading ? (
                  <Tooltip
                    placement="top"
                    title="Send mail to all users who have not received it yet."
                  >
                    <button
                      className="small-button-cotain-view-all mt-2 mt-lg-0"
                      disabled={isSendingMailToAll}
                      onClick={() => {
                        setOpenSendMailToAllConfirmation(true);
                      }}
                    >
                      {isSendingMailToAll ? (
                        "Sending..."
                      ) : (
                        <>
                          Send Mail To All{" "}
                          <Icon
                            icon="material-symbols:send-rounded"
                            className="ms-2"
                          />
                        </>
                      )}
                    </button>
                  </Tooltip>
                ) : (
                  ""
                )}
                {!isOpenInIdealCandidate && (
                  <div className="custom-input-design">
                    <div className="position-relative">
                      <select
                        value={latest}
                        className="ps-3"
                        onChange={(e) => {
                          setLatest(e.target.value);
                          setPageNumber(0);
                          setMembersList([]);
                          setIsLoading(true);
                        }}
                      >
                        {typesList.map((type) => (
                          <option key={type.value} value={type.value}>
                            {type.title}
                          </option>
                        ))}
                      </select>

                      <img
                        src={select_icon}
                        className="input-end-icon pe-none ps-2"
                        alt=""
                      />
                    </div>
                  </div>
                )}
                <div className="custom-input-design mt-2 mt-lg-0">
                  <div className="position-relative">
                    <input
                      className="ps-5"
                      placeholder={"Search candidates"}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />

                    <img
                      src={search_blue_icon}
                      className="input-start-icon"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isLoading ? (
            isOpenInIdealCandidate && isProcessingContinue ? (
              <>
                <AiLoader
                  message={
                    jobs?.scanning_cvs
                      ? "The system is currently reanalyzing candidates, which may take a few minutes. Please retry after a few minutes."
                      : ""
                  }
                />
              </>
            ) : (
              <CircularLoader />
            )
          ) : (
            <>
              <div className="row mt-2 mx-auto">
                {membersList.length > 0 && isOpenInIdealCandidate ? (
                  <>
                    <Alert severity="success" icon={<CheckCircleIcon />}>
                      <p className="mb-0">
                        The system identified{" "}
                        <Box
                          component="span"
                          fontWeight="bold"
                          color="success.main"
                        >
                          {totalCount} ideal candidate
                          {totalCount > 1
                            ? "s who are excellent"
                            : " who is an excellent"}
                        </Box>{" "}
                        fit for the job requirements.
                      </p>
                    </Alert>
                  </>
                ) : (
                  ""
                )}
                {membersList.map((candidate) => (
                  <div className="col-lg-6 mb-3">
                    <div
                      onClick={() => {
                        handleDetailPopUp(candidate);
                      }}
                      className={`candidate-card card-1  mt-3 hover-card-effect p-0 cursor-pointer ${
                        !candidate.read_status &&
                        cardToOpen === "new-candidates" &&
                        (GetAccessOfCompany("job?.add") ||
                          GetAccessOfCompany("job?.update"))
                          ? "active tw-card bg-active"
                          : ""
                      }`}
                    >
                      <div className="p-3">
                        <div className="d-flex justify-content-between tw-items-start tw-gap-3 listing-card text-start">
                          <div className="d-flex align-items-center gap-2">
                            <Avatar
                              src={candidate?.name_profile?.image}
                              alt={candidate?.first_name}
                              sx={{ width: 54, height: 54 }}
                            />
                            <div className="line-height-14">
                              <h5>
                                {candidate.first_name}{" "}
                                {candidate.last_name || ""}
                              </h5>
                              <span
                                onClick={() => {
                                  handleEmailClick(candidate.email);
                                }}
                                className="anchor hover-primary"
                              >
                                {candidate.email}
                              </span>
                            </div>
                          </div>
                          <div className="d-flex flex-column gap-2">
                            <img
                              src={eye_with_back_fill}
                              className="img-fluid ms-2 tw-w-6 tw-h-6 cursor-pointer"
                              alt="View CV"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePreviewClick(candidate);
                              }}
                            />
                            {cardToOpen === "new-candidates" &&
                              (GetAccessOfCompany("job?.add") ||
                                GetAccessOfCompany("job?.update")) && (
                                <>
                                  {candidate.read_status ? (
                                    <Tooltip title="Mark as unread">
                                      <span>
                                        {/* Read Icon - Eye with check */}
                                        <Icon
                                          icon="mdi:email-open"
                                          className="tw-w-6 tw-h-6 tw-text-green-500 cursor-pointer ms-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleMarkAsUnread(candidate, true);
                                          }}
                                        />
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Mark as read">
                                      <span>
                                        {/* Unread Icon - Eye off/outline */}
                                        <Icon
                                          icon="mdi:email"
                                          className="tw-w-6 tw-h-6 tw-text-gray-400 cursor-pointer ms-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleMarkAsRead(candidate, false);
                                          }}
                                        />
                                      </span>
                                    </Tooltip>
                                  )}
                                </>
                              )}
                          </div>
                          {/* <div className="d-flex flex-wrap align-items-center justify-content-between w-100">

                            <div className="h-100 d-flex flex-wrap flex-column align-items-end justify-content-between">
                              <div className="d-flex tw-gap-2">
                                {(GetAccessOfCompany("job?.add") ||
                                  GetAccessOfCompany("job?.update")) && (
                                    <Tooltip
                                      title={
                                        candidate.read_status
                                          ? "Mark As Unread"
                                          : "Mark As Read"
                                      }
                                      placement="top"
                                    >
                                      <button
                                        className="btn-white-bg-sm"
                                        onClick={(e) => {
                                          handleChangeReadStatus(
                                            candidate,
                                            !candidate.read_status,
                                            true
                                          );
                                        }}
                                        disabled={candidate.read_status_loading}
                                      >
                                        <Icon
                                          icon={
                                            candidate.read_status
                                              ? "hugeicons:check-unread-02"
                                              : "solar:check-read-linear"
                                          }
                                          fontSize={"16px"}
                                        />
                                      </button>
                                    </Tooltip>
                                  )}
                                <button
                                  className="btn-contained-sm"
                                  onClick={() => {
                                    handleDetailPopUp(candidate);
                                  }}
                                >
                                  View Details
                                </button>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        <div className="ms-lg-2 d-flex align-items-center mt-2 gap-2 time-icon mt-3">
                          <img src={time_icon} alt="" />
                          <span>
                            {handle_get_time_ago(candidate.createdAt)}
                          </span>
                        </div>
                      </div>
                      <div className="border-bottom-1"></div>
                      {/* <div className="w-100">
                              <div className="d-flex align-items-center mt-2 gap-2">
                                <div className="bg-light-gold tw-p-2 rounded">
                                  <Icon
                                    icon="mdi:clock-outline"
                                    width={16}
                                    height={16}
                                    color="var(--portal-secondary-color)"
                                  />
                                </div>
                                <span>
                                  {handle_get_time_ago(candidate.createdAt)}
                                </span>
                              </div>

                              {candidate?.cv && (
                                <Tooltip title="Preview CV" placement="top">
                                  <div
                                    className="d-flex align-items-center mt-2 gap-2 cursor-pointer"
                                    onClick={() => {
                                      handlePreviewClick(candidate);
                                    }}
                                  >
                                    <div className="bg-light-gold tw-p-2 rounded">
                                      <Icon
                                        icon="pepicons-pop:file"
                                        width={16}
                                        height={16}
                                        color="var(--portal-secondary-color)"
                                      />
                                    </div>
                                    <span className="">
                                      {candidate?.cv.split("/").pop()}
                                    </span>
                                    <Icon
                                      icon="mdi:eye"
                                      width={16}
                                      height={16}
                                      color={"var(--portal-primary-color)"}
                                    />
                                  </div>
                                </Tooltip>
                              )}
                            </div> */}
                      {(GetAccessOfCompany("job?.add") ||
                        GetAccessOfCompany("job?.update")) && (
                        <div className="d-flex w-100 tw-gap-2 flex-column align-items-end justify-content-between p-3">
                          {apiResponce?.setting?.mail_sent_type == "auto" &&
                            (cardToOpen == "accepted-candidates" ||
                              cardToOpen == "rejected-candidates") &&
                            !candidate.immediate_email_sent &&
                            !candidate.manual_email_sent &&
                            !candidate.schedule_email_sent && (
                              <div className="d-flex align-items-center mt-2 gap-2">
                                <Icon
                                  icon="mdi:clock-outline"
                                  width={16}
                                  height={16}
                                />

                                <span>Email Schedule: {emailSendTime}</span>
                              </div>
                            )}
                          <div className="d-flex tw-gap-2">
                            {cardToOpen !== "new-candidates" &&
                              cardToOpen !== "short_listed-candidates" && (
                                <Tooltip
                                  title={
                                    candidate.immediate_email_sent ||
                                    candidate.manual_email_sent ||
                                    candidate.schedule_email_sent
                                      ? "Email already sent. Want to Resend Email?"
                                      : ""
                                  }
                                  placement="top"
                                >
                                  <button
                                    className={
                                      (candidate.manual_email_sent ||
                                        candidate.immediate_email_sent ||
                                        candidate.schedule_email_sent) &&
                                      hoveredId != candidate._id
                                        ? "btn-outlined-sm"
                                        : "btn-contained-sm"
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSendEmailConfirmation(candidate);
                                    }}
                                    onMouseEnter={() =>
                                      setHoveredId(candidate._id)
                                    }
                                    onMouseLeave={() => setHoveredId(null)}
                                    disabled={candidate.send_email_loading}
                                  >
                                    {candidate.send_email_loading ? (
                                      "Sending Email..."
                                    ) : (candidate.manual_email_sent ||
                                        candidate.immediate_email_sent ||
                                        candidate.schedule_email_sent) &&
                                      hoveredId != candidate._id ? (
                                      <>
                                        Email Sent{" "}
                                        <Icon
                                          icon="lets-icons:check-fill"
                                          color="var(--success-color)"
                                        />
                                      </>
                                    ) : (
                                      <>
                                        Send Email{" "}
                                        <Icon icon="material-symbols:send-rounded" />
                                      </>
                                    )}
                                  </button>
                                </Tooltip>
                              )}

                            {cardToOpen == "new-candidates" && (
                              <button
                                className="btn-outlined-yellow"
                                disabled={
                                  candidate.rejected_loading ||
                                  candidate.accepted_loading ||
                                  candidate.short_listed_loading
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChangeStatusOfCandidate(
                                    candidate,
                                    "short_listed"
                                  );
                                }}
                              >
                                {candidate.short_listed_loading
                                  ? "Shortlisting..."
                                  : "Shortlist"}
                              </button>
                            )}
                            {cardToOpen !== "rejected-candidates" && (
                              <button
                                className="butn-outlined-red"
                                disabled={
                                  candidate.rejected_loading ||
                                  candidate.accepted_loading ||
                                  candidate.short_listed_loading
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChangeStatusOfCandidate(
                                    candidate,
                                    "rejected"
                                  );
                                }}
                              >
                                {candidate.rejected_loading
                                  ? "Rejecting..."
                                  : "Reject"}
                              </button>
                            )}
                            {cardToOpen !== "accepted-candidates" && (
                              <button
                                className="btn-outlined-parret"
                                disabled={
                                  candidate.rejected_loading ||
                                  candidate.accepted_loading ||
                                  candidate.short_listed_loading
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChangeStatusOfCandidate(
                                    candidate,
                                    "accepted"
                                  );
                                }}
                              >
                                {candidate.accepted_loading
                                  ? "Accepting..."
                                  : "Accept"}
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {!isLoading &&
                  totalPages > 1 &&
                  totalPages > pageNumber &&
                  membersList.length > 0 && (
                    <div className="col-12 text-center mt-3">
                      <div
                        ref={lastBookElementRef}
                        className="mt-3"
                        onClick={() => {
                          handleLoadMore();
                        }}
                        id="load-more-feed"
                      >
                        {isLoadingMore ? (
                          <CircularProgress color="primary" size={15} />
                        ) : (
                          "Load More"
                        )}
                      </div>
                    </div>
                  )}

                {/* <CustomMUITable
                TABLE_HEAD={TABLE_HEAD}
                data={membersList}
                pagePagination={true}
                no_data_message={"No Results Available"}
                MENU_OPTIONS={MENU_OPTIONS}
                custom_pagination={{
                  total_count: totalCount,
                  rows_per_page: rowsPerPage,
                  page: page,
                  handleChangePage: handleChangePage,
                  onRowsPerPageChange: handleChangeRowsPerPage,
                }}
                totalPages={totalPages}
                custom_search={{
                  searchText: searchText,
                  setSearchText: setSearchText,
                  handleSubmit: searchFunction,
                }}
                pageCount={page + 1}
                handleChangePages={(e, newPage) => {
                  handleChangePage(e, newPage - 1);
                }}
              /> */}

                {membersList.length == 0 && (
                  <>
                    <div className="mt-5">
                      <RecordNoImage title={`No Candidates Found.`} />
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        {/* Detail Popup */}

        <CustomModalLayout
          open={openDetailPopup}
          onClose={handleCloseDetailPopup}
          title={"Candidate Details"}
          subTitle={jobs?.job_title || "N/A"}
          width="850px"
          componentToPass={
            <CandidateDetails
              selectedMember={selectedMember}
              jobs={jobs}
              handleDownloadClick={handleDownloadClick}
              handlePreviewClick={handlePreviewClick}
              addCommasToNumber={addCommasToNumber}
            />
          }
        />
      </div>
    </>
  );
};

export default Candidates2;
